import React, { FC } from 'react';
import { BlocklistView } from '../components';

export const BlocklistPage: FC = () => {
  return <BlocklistView />;
};
